import { render, staticRenderFns } from "./NHNumber.vue?vue&type=template&id=716b079a&"
import script from "./NHNumber.vue?vue&type=script&lang=js&"
export * from "./NHNumber.vue?vue&type=script&lang=js&"
import style0 from "./NHNumber.vue?vue&type=style&index=0&id=716b079a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports